import Sharemail from './article/sharemail.js';
import {shareMeta} from './article/sharelinks.js';
import TeInteresa from './article/te-interesa.js';
import commentsInit from './article/gigya.js';

Logger.debug('script article loaded');

/** get main vars */
const app = Voonto.getInstance();

// Inicializar gigya comments
commentsInit();

shareMeta();

let sharemail = null;
$('.compartir-email').on('click', function () {
    if (sharemail === null) {
        sharemail = new Sharemail('.capa-compartir-email');
        sharemail.bind();
    }
    sharemail.toggle();
});

Voonto.$('[data-voc-vam]').on('vam:isempty', function () {
    Logger.info('[VAM] Ad slot is empty, hide parent');
    Voonto.$(this).parent().hide();
});

/** sticky teInteresa|ads */
if (Voonto.is.mobile() || Voonto.is.tablet()) {
    let $stickyAds = Voonto.$('.publi-sticky');
    $stickyAds.find('[data-voc-vam]').on('vam:isempty', function () {
        Logger.info('[data-voc-vam][Breaking News] position megabanner_sticky is empty');
        let $urgente = Voonto.$('.urgente-teinteresa');
        let showTeInteresa = true;
        if ($urgente.length > 0) {
            let $cerrarUrgente = $urgente.find('.cerrar');
            let type = $cerrarUrgente.data('type');
            if (type === 'urgente') {
                if (compruebaCookie()) {
                    Logger.info('[data-voc-vam][Breaking News] urgente hide. Existe cookie');
                } else {
                    Logger.info('[data-voc-vam][Breaking News] urgente show. No existe cookie');
                    showTeInteresa = false;
                }
            } else {
                Logger.info('[data-voc-vam][Breaking News] urgente show. existe urgente múltiple');
                showTeInteresa = false;
            }
        }

        if (!showTeInteresa) {
            Logger.info('BreakingNews ad slot is empty but exist urgente');
            $stickyAds.hide();
        } else {
            Logger.info('BreakingNews ad slot is empty');
            $stickyAds.hide();
            let teinteresa = new TeInteresa();
            teinteresa.load(Voonto.$('#breaking-news-container'));
        }
    });

    $stickyAds.find('[data-voc-vam]').on('vam:inactive', function () {
        Logger.info('[data-voc-vam][Breaking News] position megabanner_sticky is inactive');
        let $urgente = Voonto.$('.urgente-teinteresa');
        let showTeInteresa = true;
        if ($urgente.length > 0) {
            let $cerrarUrgente = $urgente.find('.cerrar');
            let type = $cerrarUrgente.data('type');
            if (type === 'urgente') {
                if (compruebaCookie()) {
                    Logger.info('[data-voc-vam][Breaking News] urgente hide. Existe cookie');
                } else {
                    Logger.info('[data-voc-vam][Breaking News] urgente show. No existe cookie');
                    showTeInteresa = false;
                }
            } else {
                Logger.info('[data-voc-vam][Breaking News] urgente show. existe urgente múltiple');
                showTeInteresa = false;
            }
        }

        if (!showTeInteresa) {
            Logger.info('BreakingNews ad slot is inactive but exist urgente');
            $stickyAds.hide();
        } else {
            Logger.info('BreakingNews ad slot is inactive');
            $stickyAds.hide();
            let teinteresa = new TeInteresa();
            teinteresa.load(Voonto.$('#breaking-news-container'));
        }
    });

    $stickyAds.find('[data-voc-vam]').on('vam:slotrendered', function () {
        let $urgente = Voonto.$('.urgente-teinteresa');
        let showTeInteresa = true;
        if ($urgente.length > 0) {
            let $cerrarUrgente = $urgente.find('.cerrar');
            let type = $cerrarUrgente.data('type');
            if (type === 'urgente') {
                if (compruebaCookie()) {
                    Logger.info('[data-voc-vam][Breaking News] urgente hide. Existe cookie');
                } else {
                    Logger.info('[data-voc-vam][Breaking News] urgente show. No existe cookie');
                    showTeInteresa = false;
                }
            } else {
                Logger.info('[data-voc-vam][Breaking News] urgente show. existe urgente múltiple');
                showTeInteresa = false;
            }
        }

        if (!showTeInteresa) {
            Logger.info('[data-voc-vam][Breaking News] ad slot is active but exist urgente');
            $stickyAds.hide();
        } else {
            Logger.info('[data-voc-vam][Breaking News] ad slot is active');
            $stickyAds.show();
        }
    });

    $stickyAds.on('click', function () {
        Voonto.$(this).hide();
    });

    // Comportamiento para cerrar el menu de compartir cuando se hace scroll
    let inputShareLayer = Voonto.$('input#capa_compartir'),
        labelShareLayer = Voonto.$('label[for="capa_compartir"]'),
        inputFixedLayer = Voonto.$('input#capa_compartir_fija'),
        labelFixedLayer = Voonto.$('label[for="capa_compartir_fija"]'),
        containerShareLayer = Voonto.$('aside.herramientas:not(.fija) .mas-compartir'),
        containerShareFixedLayer = Voonto.$('aside.herramientas.fija .mas-compartir');

    let closeShareLayerHandler = () => {
        Logger.info('[CloseShareLayerHandler] scrolled');

        if (inputShareLayer.prop('checked') === true) {
            inputShareLayer.prop('checked', false);
            Logger.info('[CloseShareLayerHandler] ShareLayer abierta, cerrando..');
        }

        Voonto.$(window).unbind('scroll', this);
        Voonto.$(document).unbind('click', closeClickDocumentShareLayerHandler);

    };

    let closeFixedShareLayerHandler = () => {
        Logger.info('[CloseFixedShareLayerHandler] scrolled');

        if (inputFixedLayer.prop('checked') === true) {
            inputFixedLayer.prop('checked', false);
            Logger.info('[CloseShareLayerHandler] ShareFixedLayer abierta, cerrando..');
        }

        Voonto.$(window).unbind('scroll', this);
        Voonto.$(document).unbind('click', closeClickDocumentShareLayerHandler);
    };

    let closeClickDocumentShareLayerHandler = (e) => {
        Logger.info('[CloseShareLayerHandler] document onclick');

        if (inputShareLayer.prop('checked') === true) {
            // esta abierto el menu compartir
            if (Voonto.$.contains(containerShareLayer.get(0), e.target) === false
                && Voonto.$.contains(labelShareLayer.get(0), e.target) === false) {
                inputShareLayer.prop('checked', false);
                Voonto.$(document).unbind('click', this);
                Voonto.$(window).unbind('scroll', closeShareLayerHandler);
                Logger.info('[CloseShareLayerHandler] ShareLayer abierta, cerrando..');
            }
        }

        if (inputFixedLayer.prop('checked') === true) {
            // esta abierto el menu compartir de la barra fija
            if (Voonto.$.contains(containerShareFixedLayer.get(0), e.target) === false
                && Voonto.$.contains(labelFixedLayer.get(0), e.target) === false) {
                inputFixedLayer.prop('checked', false);
                Voonto.$(document).unbind('click', this);
                Voonto.$(window).unbind('scroll', closeFixedShareLayerHandler);
                Logger.info('[CloseShareLayerHandler] ShareFixedLayer abierta, cerrando..');
            }
        }
    };

    inputShareLayer.on('change', function () {
        let $this = Voonto.$(this);
        Logger.info('[CloseShareLayerHandler] input change');
        if ($this.prop('checked') === true) {
            Voonto.$(window).one('scroll', closeShareLayerHandler);
            Voonto.$(document)
                .unbind('click', closeClickDocumentShareLayerHandler)
                .on('click', closeClickDocumentShareLayerHandler);
        } else {
            Voonto.$(window).unbind('scroll', closeShareLayerHandler);
            Voonto.$(document).unbind('click', closeClickDocumentShareLayerHandler);
        }
    });

    inputFixedLayer.on('change', function () {
        let $this = Voonto.$(this);
        Logger.info('[CloseFixedShareLayerHandler] input change');
        if ($this.prop('checked') === true) {
            Voonto.$(window).one('scroll', closeFixedShareLayerHandler);
            Voonto.$(document)
                .unbind('click', closeClickDocumentShareLayerHandler)
                .on('click', closeClickDocumentShareLayerHandler);
        } else {
            Voonto.$(window).unbind('scroll', closeFixedShareLayerHandler);
            Voonto.$(document).unbind('click', closeClickDocumentShareLayerHandler);
        }
    });


}

function compruebaCookie() {
    Logger.info('[Breaking News] compruebaCookieWebPush');
    let src = 'BreakingNews-ABC';
    Logger.info('[Breaking News] src: ' + src);
    return !(Cookies(src) === null || Cookies(src) === "" || Cookies(src) === "null" || typeof Cookies(src) === 'undefined');
}






// WEBPACK FOOTER //
// ./src/scripts/article-script.js